export default {
  // Bosnia* bs(languagecode) BS(countrycode) Босна и Херцеговина / Босански
  LandingPage: {
    intro_sub:
      'Jepni një jetë tjetër paketave të mbetura dhe merrni pjesë në mbrojtjen e mjedisit.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Bashkohuni me ne në reduktimin e mbeturinave',
    sequence1_2:
      'për një mjedis të qëndrueshëm duke ripërdorur paketimin e produkt tuaj për gjëra të dobishme. Shkoni poshtë për të bërë hapin tuaj të parë.',
    sequence2_1: 'Ju prezantojmë Samsung Upcycle-Packaging',
    sequence2_2:
      "Një kuti televizori e projektuar posaçërisht për t'u përpunuar për kontributin tuaj mbrojtjes së mjedisit. Bëni sende të ndryshme shtëpiake me kutinë e produkt tuaj.",
    sequence3_1: 'Ndiqni pikat e printuara në paketim',
    sequence3_2:
      'Priteni paketën siç udhëzohet dhe mblidheni për të krijuar diçka të mahnitshme.',
    sequence4_1: 'Zgjidhni sendin që dëshironi të bëni',
    sequence4_2:
      'Shkoni poshtë dhe gjeni modelin e produkt që keni në paketën tuaj. Pastaj gjeni variantet e ndryshme të dizajnit për ju. Tani, filloni udhëtimin tuaj me sendin që dëshironi të krijoni.',
    selectBox: 'Zgjidhni produkt tuaj',
    moreActivity:
      "Për më shumë informacion në lidhje me aktivitetet e qëndrueshme në Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Seti 1',
    SoundbarSet02:'Soundbar Seti 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    /*moreActivityLink:
      'https://www.samsung.com/ba/sustainability/overview/',*/
    //moreActivityLink:'https://www.samsung.com/hr/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/hr/sustainability/overview/',
    footer: `
    copyright © 2019-2021 SAMSUNG Sva prava zadržana.`,
  },
  ProductPage: {
    selectDesign: 'Zgjidhni dizajnin për të krijuar',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Konsolë TV',
    StorageBox: 'Kuti magazinimi',
    MagazineRack: 'Mbajtëse revistash',
    CatHouse: 'Shtëpi për mace',
    CatTunnel: 'Tunel për mace',
    BookShelf: 'Raft librash',
    DeskShelf: 'Raft tryeze',
    BlackRhino: 'Kafshë të rrezikuara \n Rinoqeronti i Zi', //update
    PolarBear: 'Kafshët e rrezikuara \n Ariu Polar', //update
    SeaTurtle: 'Kafshët e rrezikuara \n Breshka e Detit', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Mozaik Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Minitavolinë mbështetëse \n krahu Alex Couch', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Tavolinë kinoko', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Mbajtëse \n kartolinash', //update
    SneakerRack: 'Mbajtëse \n atletesh', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Kuti veglash', //update
    DeskStationary: 'Mbajtëse lapsash',
    CoinBank: 'Mbajtëse monedhash',
    MobileScanner:'Mbajtëse për skanim me smartfon',
    TabletScanner:'Mbajtëse për skanim me tablet',
    PetStairs:'Stepenice za kućne ljubimce',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'min',
    all:'ALL',
    in: 'në',
    inOnly: 'në vetëm',
    allBoxSize: 'Të gjitha madhësitë e kutive',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Udhëzimet',
    prepare: 'Përgatitni kutinë',
    LetsDesign: "Le të dizajnojmë",
    drawParts: 'Vizatoni pjesët në kuti',
    note1: 'Vini re se pozicioni grafik mund të ndryshojë në varësi të vendet dhe madhësive',
    note2: 'Skiconi të gjithë vizatimin së pari, në mënyrë që të përshtatet në kuti',
    numberSpace: 'numri = hapësira midis pikave',
    diagonal: 'diagonal',
    LEFT: 'E MAJTA (pjesa)',
    RIGHT: 'E DJATHTA (pjesa)',
    TOP: 'E SIPËRME (pjesa)',
    TOP1: 'E SIPËRME (pjesa) 1',
    TOP2: 'E SIPËRME (pjesa) 2',
    BACK: 'E PRAPME (pjesa)',
    MIDDLE: 'E MESME (pjesa)',
    MIDDLE2: 'E MESME (pjesa) 2',
    BOTTOM: 'E POSHTME (pjesa)',
    FRONT: 'E PËRPARME (pjesa)',
    SIDE: 'ANËSORE (pjesa)',
    secondSIDE: 'ANA TJETËR (pjesa)',
    secondSIDE1: 'ANA TJETËR (pjesa) 1',
    secondSIDE2: 'ANA TJETËR (pjesa) 2',
    LEG: 'KËMBA (pjesë)', //update
    JOINT: 'E PËRBASHKËT (pjesa)', //update
    FACE: 'BALLORE (pjesa)', //update
    DRAWERBOTTOM: 'E POSHTME E SIRTARIT (pjesa)', //update
    DRAWERSIDE: 'ANËSORE E SIRTARIT (pjesa)', //update
    NOSE: 'HUNDA (pjesa)', //update
    HANDLE: 'DOREZA (pjesa)', //update
    BOTTOMSIDE: 'ANA E POSHTME (pjesa)', //update
    TOPSIDE: 'ANA E SIPËRME (pjesa)', //update
    WING: 'KRAHU (pjesa)', //update
    cutAndAssemble: "Le të presim dhe të mbledhim",
    beCareful: 'Kini kujdes që të mos të prisni veten duke përdorur gërshërën',
    cutOutParts: 'Prisni pjesët',
    assemble: 'Mblidhini',
    Assemblyguide: 'Udhëzuesi për mbledhjen', //update
    fold: 'Shembulli i palosjes',
    foldGuide: 'Përdorni anën e mobilieve kur palosni kartonin',
    foldGuideDezeen:
      'Shtypni vijën me pika në karton me mjete të forta disa herë, për të ndihmuar që kartoni të paloset', //update
    glue: 'Vendosni zamkë ose shirit ngjitës në mënyrë të barabartë në sipërfaqe', //update
    cable: "Përdorni fije ose tela për t'i lidhur", //update
    done: 'Kaq!',
    goBack: 'Kthehuni te menyja kryesore',
  },
  CautionPage: {
    CAUTION: 'KUJDES',
    needItem: "Do t'ju duhen këto sende",
    children: 'Fëmijët duhet të jenë me të rriturit',
    mat:
      'Ju lutemi vendosni një mbulesë në tokë për të mos bërë gërvishtje gjatë procesit',
    doNotPutHeavyThing:
      'Mos shkelni ose mos u ulni mbi sendet dhe përpiquni të mos vendosni gjëra të rënda mbi to',
    doNotThrow:
      'Mos hidhni ose shkelmoni orenditë drejt asnjë gjëje, përfshirë njerëz dhe kafshë',
    stayAwayFlame: 'Qëndroni larg flakëve',
    stayAwayWater: 'Mos i afroni ato ujit ose lagështisë',
    mayDamaged: '* Kutia e TV-së mund të jetë dëmtuar gjatë transportit',
    companyDoestResponsible:
      '* Kompania nuk ka asnjë përgjegjësi ndaj prishjeve ose lëndimeve gjatë kësaj pune',
    cannotBeReturned:
      '* Produkti me kuti të dëmtuara nuk mund të kthehet për çështje që nuk kanë të bëjnë me cilësinë',
    understand: 'Ok, e kuptova',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Ne kemi përdorur më pak letër dhe bojë për shumicën e paketimeve tona për televizorë në krahasim me paketimet tona të mëparshme, për të rritur angazhimin tonë për qëndrueshmërinë',
      text2:'',
      text2_special:
        '(* E mësipërmja nuk vlen për disa modele, duke përfshirë TV-të Lifestyle)',
      text3: 'Shtypni butonat më poshtë për të zbuluar më shumë',
    },
    greenIn: {
      title: 'Going Green në paketimin e TV-ve',
      subtitle1: 'Kërkoni për informacionin e produktit',
      subtitle2: 'Ripërdorimi Eco-Package',
      desc: 'Kërkoni emrin e modelit për më shumë informacion',
      descM: '* Bëni një foto të numrit të modelit të TV-së',
      guide: 'emri i modelit',
      button: 'Bëni foto',
      button2: 'Shkoni te Bërja e sendeve',
      product_info: 'Informacion për produktet',
    },
    search: {
      guide: 'Kërkim..',
      noResult: 'Nuk ka rezultate',
      more: 'MË SHUMË',
      search: 'Kërko',
      retake: 'Rimerr',
      result: 'Rezultati',
    },
    photo: {
      guide1: 'Vendos emrin e modelit të TV-së në kuti',
      guide2: '(e.g Q800A, UT7000, RU7100, etj)',
    },
  },
  searchCountrySelect: 'Zgjidhni një shtet për të kërkuar'
};
